import React from "react";
import { Box, Link } from "@mui/material";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import Avatar from "components/v2/common/Avatar";
import _ from "lodash";

export default function CommentHeaderDetails({
  link,
  post,
  sourceName,
  organizationName,
}) {
  const caption = _.get(post, "caption");
  const imageUrl = _.get(post, "imageUrl");
  const title = sourceName
    ? `Comment on ${sourceName} post`
    : "Comment on post";

  return (
    <Box sx={styles.wrapper}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "13px" }}>
        <Avatar
          src={imageUrl || undefined}
          userName={organizationName}
          alt={organizationName || title}
          background={"dark"}
          initialsCount={2}
          style={styles.avatar}
          variant="square"
        />
        <Box>
          <Box as="p" sx={styles.title}>
            {title}
          </Box>
          {caption && (
            <Box as="p" sx={styles.caption}>
              {caption}
            </Box>
          )}
        </Box>
      </Box>

      <Box minWidth="max-content">
        {link && (
          <Link
            sx={styles.viewPost}
            target="_blank"
            rel="noopener noreferrer"
            href={`${link}`}
          >
            View on post
            <NorthEastIcon style={{ fontSize: "16px" }} />
          </Link>
        )}
      </Box>
    </Box>
  );
}

const styles = {
  wrapper: {
    boxShadow: "rgba(18, 38, 27, 0.05) 0px 1px 3px",
    display: "flex",
    alignItems: "center",
    gap: "20px",
    justifyContent: "space-between",
    padding: "15px",
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
  },
  avatar: {
    width: "52px",
    height: "52px",
    fontSize: "14px",
    textTransform: "capitalize",
    borderRadius: "10px",
  },
  title: {
    color: "#8a938a",
    m: 0,
    fontFamily: "FustatRegular",
    fontSize: "14px",
    textTransform: "uppercase",
  },
  caption: {
    color: "#33413a",
    m: 0,
    fontFamily: "FustatMedium",
    fontSize: "14px",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  viewPost: {
    color: "#3a5344",
    fontSize: "12px",
    fontFamily: "FustatBold",
    cursor: "pointer",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    "&:hover": {
      color: "#3a5344",
      textDecoration: "none",
    },
  },
};
